<template>
  <div class="classification" :style="{margin:`0 ${config.margin_num}px`, background:`${config.bg_color || 'none'}`}">
    <van-swipe
      ref="swipe"
      :loop="loop"
      :autoplay="2000"
      :duration="duration"
      :show-indicators="false"
      :width="width"
      :height="height"
      v-if="config.type === 1"
      @change="handleChange"
    >
      <van-swipe-item
        v-for="(item, index) in swipeData"
        @click="handleSelect(item)"
        :key="index"
      >
        <div
          v-if="item.imgUrl || isEditorStatus"
          @click="jump(item.link_data)"
          :class="[
            'classification-sub',
            { suck: index % 2 === 0 },
            { breathe: index % 2 },
          ]"
          :title="item.link_name || '未命名'"
          :style="`background-color:${item.background_color};`"
        >
          <div class="MainTitle" :style="`color:${item.main_title_color}`">
            {{ item.main_title }}
          </div>
          <div class="img_box">
            <img :src="item.imgUrl" alt="" v-if="item.imgUrl" />
            <div
              class="SubTitle"
              :style="`background-color:${item.sub_title_background};color:${item.sub_title_color}`"
              v-if="item.sub_title"
            >
              {{ item.sub_title }}
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <van-swipe
      ref="swipe"
      :loop="loop"
      :duration="duration"
      :autoplay="2000"
      :show-indicators="false"
      :width="width"
      :height="height"
      @change="handleChange"
      v-if="config.type === 2"
    >
      <van-swipe-item
        v-for="(item, index) in swipeData"
        @click="handleSelect(item)"
        :key="index"
      >
        <div
          v-if="item.imgUrl || isEditorStatus"
          @click="jump(item.link_data)"
          :class="[
            'classification-sub2',
            { suck: index % 2 === 0 },
            { breathe: index % 2 },
          ]"
          :title="item.link_name || '未命名'"
          :style="`background-color:${item.background_color};`"
        >
          <div class="img_box">
            <img :src="item.imgUrl" alt="" v-if="item.imgUrl" />
            <div
              class="SubTitle"
              :style="`background-color:${item.sub_title_background};color:${item.sub_title_color}`"
              v-if="item.sub_title"
            >
              {{ item.sub_title }}
            </div>
          </div>
          <div class="MainTitle" :style="`color:${item.main_title_color}`">
            {{ item.main_title }}
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-swiper-nav",

  props: {
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    isEditorStatus: Boolean,
  },
  data() {
    return {
      isScroll: false,
      width: 100,
      duration: 500, // 动画时长默认值
      height: 95,
      loop: false,
      arrData: [],
    };
  },
  computed: {
    swipeData() {
      if (this.config.link_data.length > 3) {
        this.loop = true;
        this.arrData = this.config.link_data;
        return [
          ...this.config.link_data,
          ...this.config.link_data,
          ...this.config.link_data,
          ...this.config.link_data,
        ];
      } else {
        this.loop = false;
        return this.config.link_data;
      }
    },
  },

  methods: {
    handleChange(index) {
      if (!this.loop) return;
      // loop 功能 以下
      const mid = this.swipeData.length / 2;
      if (index === mid) {
        setTimeout(() => {
          if (this.$refs.swipe) {
            this.$refs.swipe.swipeTo(0, { immediate: true });
          }
        }, this.duration);
      }
    },
    handleSelect(item) {
      this.jump(item.link_data);
    },
    jump(link) {
      if (this.isEditorStatus || !link) {
        return;
      }
      redirectURL(link.toString(), "seller");
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>